import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-vaccination-record',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './vaccination-record.component.html',
    styleUrl: './vaccination-record.component.scss'
})
export class VaccinationRecordComponent {
    temperatureUnit: string = '℃';
    @Input() waterTemperature: number | null = null;

    @Input() vaccination: any | null = null;
    @Input() placement: any | null = null;

    @Input() id: number | null = null;
    @Input() placementId: number | null = null;
    @Input() placementName: string | null = null;
    @Input() userName: string | null = null;
    @Input() brandId: number | null = null;
    @Input() brandName: string | null = null;
    @Input() chicksTypeId: number | null = null;
    @Input() chicksType: string | null = null;
    @Input() createdOn: string | Date | null = null;
    @Input() age: number | null = null;
    @Input() notes: string | null = null;
}
